import React, { Component } from 'react';

//React-PDF dependencies
import { View, Image, StyleSheet } from "@react-pdf/renderer";

// Promise based HTTP client for the browser and node.js
import axios from 'axios';

// Import placeholder image (cause: CORS problem in the iframe preview)
import placeholder from '../../../assets/image_placeholder1000x1000.png';

const styles = StyleSheet.create({
  image: {
    transform: 'rotate(90deg)',
    marginRight: 5,
    container: {
      margin: '40px -30px',
      padding: 5,
      maxWidth: 300,
      maxHeight: 600,
    },
  },
});

class AsyncPdfImage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      image: "",
    };
  }

  componentDidMount() {
    const that = this;

    async function getImage() {
      try {

        var size_param = ""
        if (that.props.size !== null) size_param = '?size=' + that.props.size;
        const response = await axios.get(process.env.REACT_APP_BACKEND_BASE_URL+ '/projects/'+ that.props.projectId +'/image/'+ that.props.imageId + size_param  , { headers: { 'Authorization': localStorage.getItem("token") }, responseType: 'arraybuffer' });

        if (response.status === 200) {
          that.setState({ loaded: true });
          that.setState({ image: Buffer.from(response.data, 'binary').toString('base64') });
          if(that.props && that.props.data) {
            let index = that.props.data.images.findIndex((element) => element.id === that.props.imageId);
            that.props.data.images[index] = {id: that.props.imageId, loaded:that.state.loaded};
          }
        }

        return response
      } catch (error) {
        console.error(error);
      }
    }

    getImage();
  }

  render () {

    if(this.props && this.props.data) {
      if(!this.props.data.images.some(element => element.id === this.props.imageId)) {
        this.props.data.images.push({id: this.props.imageId, loaded:this.state.loaded});
      }
    }
    return (
      <View style={styles.image.container}>
        { this.state.loaded ?
          <Image
            src={"data:image/jpeg;base64," + this.state.image}
            alt={this.props.imageId}
            style={styles.image}
          /> : (<Image src={placeholder} style={styles.image}/>)
        }
      </View>
    );
  }

}

export default AsyncPdfImage;


// WEBPACK FOOTER //
// src/components/innerComponents/pdfComponents/AsyncPdfImage.js